import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=daacc9de&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
import style0 from "./Phone.vue?vue&type=style&index=0&id=daacc9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daacc9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daacc9de')) {
      api.createRecord('daacc9de', component.options)
    } else {
      api.reload('daacc9de', component.options)
    }
    module.hot.accept("./Phone.vue?vue&type=template&id=daacc9de&scoped=true&", function () {
      api.rerender('daacc9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Phone.vue"
export default component.exports